import { createPortal } from "react-dom";

export function AWSWAFCaptchaModal() {
  // createPortal is used to render the modal outside of the normal React tree
  return createPortal(
    <div
      id="modalOverlay"
      style={{
        display: "none",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1000,
      }}>
      <div
        id="modal"
        style={{
          display: "none",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          padding: "1rem",
          borderRadius: "5px",
          zIndex: 1001,
        }}>
        <form id="captchaForm"></form>
      </div>
    </div>,
    document.body
  );
}
